/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBackToTopProps } from './back-to-top.props.autogenerated';

export interface IBackToTopData {}

class BackToTop extends React.PureComponent<IBackToTopProps<IBackToTopData>> {
    public render(): JSX.Element | null {
        if (!this.props.config.showBackToTop) {
            return null;
        }
        return this.props.renderView(this.props);
    }
}

export default BackToTop;
